import React from "react";

const JobBoardComponent = ({
  job: {
    company,
    logo,
    isNew,
    featured,
    position,
    role,
    level,
    postedAt,
    contract,
    location,
    languages,
    tools,
  },
  handleTagClick,
}) => {
  const tags = [role, level];
  if (tools) {
    tags.push(...tools);
  }
  if (languages) {
    tags.push(...languages);
  }
  return (
    <div
      className={`flex flex-col bg-white shadow-md mx-10 my-16 m-4 p-6 rounded sm:my-8 ${
        featured && "border-l-4 border-blue-500 border-solid"
      } sm:flex-row `}
    >
      <div>
        <img
          className="-mt-16 mb-2 h-[75px] w-[75px] sm:mt-0 sm:my-0 "
          src={logo}
          alt={company}
        />
      </div>
      <div className="flex flex-col justify-between ml-4">
        <h3 className="font-bold text-Blue-900">
          {company}{" "}
          {isNew && (
            <span className="text-sm bg-blue-900 text-white font-bold m-2 py-1 px-2 rounded-full uppercase">
              New
            </span>
          )}{" "}
          {featured && (
            <span className="text-sm bg-blue-900  text-white font-bold m-2 py-1 px-2 rounded-full uppercase">
              Featured
            </span>
          )}
        </h3>
        <h2 className="font-bold text-xl">{position}</h2>
        <p className="text-gray-600">
          {postedAt} | {contract} | {location}
        </p>
      </div>
      <div className="flex flex-wrap items-center mt-4 mx-2 pt-2 border-t border-gray-500 sm:ml-auto sm:border-0 sm:mt-0 sm:pt-0 ">
        {tags
          ? tags.map((tag) => (
              <span
                onClick={() => handleTagClick(tag)}
                className="cursor-pointer text-white bg-blue-900 bg-opacity-100 font-bold mb-2 mr-4 p-2 rounded  sm:mb-0 "
              >
                {tag}
              </span>
            ))
          : ""}
        <div>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfXp6T7RRRBNiXfDy926LUaJKa3X-1x61_fxlTG4I8jYxzQmQ/viewform?usp=header"
            target="_blank"
            className="text-white bg-blue-900 hover:bg-green-800 inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0"
          >
            Apply Now
            <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
          </a>
        </div>
      </div>
    </div>
  );
};
export default JobBoardComponent;
